module.exports = __webpack_public_path__ + "img/laravel.9fe29a6f.png";